import { catchError, mapTo, Observable, of } from 'rxjs';
import { HttpClientInterface } from '@itk/http-client-interface';
import {
  Token,
  TokenRefreshRequest,
  TokenVerifyRequest,
} from '../models/token.model';

export class TokensEndpoint {
  constructor(private readonly http: HttpClientInterface) {}

  refreshToken(refreshTokenRequest: TokenRefreshRequest): Observable<Token> {
    return this.http.post<Token, TokenRefreshRequest>({
      url: '/token/refresh/',
      body: refreshTokenRequest,
    });
  }

  verifyToken(authTokenRequest: TokenVerifyRequest): Observable<boolean> {
    return this.http
      .post<Record<string, string | number>, TokenVerifyRequest>({
        url: '/token/verify/',
        body: authTokenRequest,
      })
      .pipe(
        mapTo(true),
        catchError(() => of(false)),
      );
  }
}
